import axios from "axios";
const API_URL = "https://magangprodb.herokuapp.com/api/v1/";

class UploadCvService {
  upload(file, onUploadProgress, idPeserta) {
    let formData = new FormData();

    formData.append("file", file);

    return axios.post(API_URL + "cv/upload/" + idPeserta, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
      onUploadProgress,
    });
  }


  getFiles() {
    return axios.get(API_URL + "cv/files");
  }
}
export default new UploadCvService();
